import { BIBLIOTECA_ACTIONS } from 'app/store/actions/media/ebooks.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { EBooksInitialState } from 'app/types/ebooks-reducers.types'

const initialState: EBooksInitialState = {
  data: [],
  loading: true,
  error: false,
}

const Biblioteca = baseRequestReducer(initialState, BIBLIOTECA_ACTIONS)

export default Biblioteca
